export default [
	{
		path: '/online-dossier/:token',
		name: 'onlineDossier',
		component: () => import(/* webpackChunkName: "onlineDossier" */ '@/views/online-dossier/Index.vue'),
		meta: {
			title: 'Online dossier',
			requiresAuth: false,
			onlineDossier: true,
		},
	},
	{
		path: '/online-dossier/:token/opdrachtgever',
		name: 'onlineDossierCustomer',
		component: () => import(/* webpackChunkName: "onlineDossierCustomer" */ '@/views/online-dossier/Customer.vue'),
		meta: {
			title: 'Opdrachtgever | Online dossier',
			requiresAuth: false,
			onlineDossier: true,
		},
	},
	{
		path: '/online-dossier/:token/bedrijfsgegevens',
		name: 'onlineDossierCompany',
		component: () => import(/* webpackChunkName: "onlineDossierCompany" */ '@/views/online-dossier/Company.vue'),
		meta: {
			title: 'Bedrijfsgegevens | Online dossier',
			requiresAuth: false,
			onlineDossier: true,
		},
	},
	{
		path: '/online-dossier/:token/:object',
		name: 'onlineDossierObject',
		component: () => import(/* webpackChunkName: "onlineDossierObject" */ '@/views/online-dossier/Object.vue'),
		meta: {
			title: 'Object | Online dossier',
			requiresAuth: false,
			onlineDossier: true,
		},
	},
];